function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgLastPhase = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 72.85999,
    y1: 56.06101,
    x2: 69.23916,
    y2: 58.64346,
    style: {
      fill: "none",
      stroke: "#ff7d49",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1708225825773262px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 85.24389,
    y1: 61.79429,
    x2: 84.95521,
    y2: 66.40292,
    style: {
      fill: "none",
      stroke: "#ff7d49",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1708225825773262px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.94077,49.78855c4.76691,6.96389,11.71337,9.13083,19.013,9.1082",
    style: {
      fill: "none",
      stroke: "#ff7d49",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1708225825773262px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.22136,49.26023c-5.03779-.46087-8.04121-2.87584-10.72367-4.87267",
    style: {
      fill: "none",
      stroke: "#ff7d49",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1708225825773262px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.24848,58.66862c-.04684.28688-.09955.56786-.15807.85471a3.22954,3.22954,0,0,1-3.612,2.49972c-3.79349-.51517-10.713-2.15431-15.91148-7.40547a3.25066,3.25066,0,0,1-.21077-4.40227c.16393-.18733.33955-.38639.52688-.59127a20.097,20.097,0,0,1,7.53424-5.21017c.35127-.13464.71422-.26345,1.083-.37468a7.77021,7.77021,0,0,1,9.5656,4.777q.11415.31611.22832.6498A19.62863,19.62863,0,0,1,91.24848,58.66862Z",
    style: {
      fill: "none",
      stroke: "#276ef1",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1708225825773262px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.02758,61.03332s54.04114-23.07375,93.1046,14.5729",
    style: {
      fill: "none",
      stroke: "#6e6bb3",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "1.1708225825773262px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "45.672 60.909 48.302 21.325 68.093 22.64 60.34 29.428 67.504 37.612 47.742 36.502",
    style: {
      fill: "none",
      stroke: "#276ef1",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1708225825773262px"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 72.10603,
    cy: 70.30459,
    rx: 3.45978,
    ry: 8.57569,
    transform: "translate(-21.00792 108.66871) rotate(-66.66754)",
    style: {
      fill: "none",
      stroke: "#6e6bb3",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1708225825773262px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.80654,76.8361c-1.15892,2.6868-7.49719,2.53618-14.15691-.33642s-11.119-7.37939-9.96008-10.06619",
    style: {
      fill: "none",
      stroke: "#6e6bb3",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1708225825773262px"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.10121,
    cy: 64.82825,
    rx: 7.22517,
    ry: 2.91493,
    transform: "translate(-8.69639 3.50887) rotate(-7.88726)",
    style: {
      fill: "none",
      stroke: "#6e6bb3",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1708225825773262px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.38382,64.42472c.33829,2.442-4.29426,5.10132-10.34711,5.93985s-11.23388-.4613-11.57218-2.90327",
    style: {
      fill: "none",
      stroke: "#6e6bb3",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1708225825773262px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.31712,
    cy: 51.98768,
    r: 2.57237,
    style: {
      fill: "none",
      stroke: "#276ef1",
      strokeMiterlimit: 10,
      strokeWidth: "1.1708225825773262px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.58769,45.63592a2.48011,2.48011,0,0,1,.35271,1.25344,2.57417,2.57417,0,0,1-4.535,1.708",
    style: {
      fill: "none",
      stroke: "#276ef1",
      strokeMiterlimit: 10,
      strokeWidth: "1.1708225825773262px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.13256,51.52237A2.57307,2.57307,0,0,0,90.386,56.659a1.86082,1.86082,0,0,0,.36247-.03477",
    style: {
      fill: "none",
      stroke: "#276ef1",
      strokeMiterlimit: 10,
      strokeWidth: "1.1708225825773262px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.67631,61.06276h0a3.41584,3.41584,0,0,1,3.41584,3.41584v.11019a0,0,0,0,1,0,0H42.26047a0,0,0,0,1,0,0v-.11019a3.41584,3.41584,0,0,1,3.41584-3.41584Z",
    transform: "translate(4.26514 -2.88966) rotate(3.80088)",
    style: {
      fill: "none",
      stroke: "#276ef1",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1708225825773262px"
    }
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgLastPhase);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/last-phase.3d69376b3f5c108d82cee5cc8c3a7e8b.svg";